import React, {useState, useEffect, createRef} from "react";
import {DataGrid, Column, Summary, TotalItem} from 'devextreme-react/data-grid';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import {inject, observer} from "mobx-react";
import {jsPDF} from "jspdf";
import {exportDataGrid as exportDataGridToPdf} from "devextreme/pdf_exporter";
import format from "date-fns/format";

function DetailTemplate(props) {

    const {DataStore, data} = props
    const {details} = DataStore
    const {driverId, driver} = data.data

    const [dataSource, setDataSource] = useState(null)

    const dataGridRef = createRef();

    useEffect(() => {
        const source = getDetails(driverId)
        setDataSource(source)
    }, [data])

    function getDetails(key) {
        return new DataSource({
            store: new ArrayStore({
                data: details,
                key: 'driverId'
            }),
            filter: ['driverId', '=', key]
        });
    }

    function exportGridPDF() {
        const pdfDoc = new jsPDF('l', 'pt', "a4");
        const dataGrid = dataGridRef.current.instance;

        const options = {
            jsPDFDocument: pdfDoc,
            component: dataGrid,
            autoTableOptions: {
                margin: {top: 60, left: 15}
            },
        }

        exportDataGridToPdf(options).then(() => {
            pdfDoc.setFontSize(12);
            const pageCount = pdfDoc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdfDoc.setPage(i);
                const pageSize = pdfDoc.internal.pageSize;
                const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                const header = driver;
                const report = `Cobros y pagos`
                const date = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`
                const footer = `Pagina ${i} de ${pageCount}`;

                // Header
                pdfDoc.setFontSize(14)
                pdfDoc.setFont('helvetica', '', 'bold')
                pdfDoc.text(header, 15, 15, {baseline: 'top'});
                pdfDoc.setFontSize(12)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(report, 15, 30, {baseline: 'top'});
                pdfDoc.setFontSize(8)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(date, 15, 45, {baseline: 'top'});
                // Footer
                pdfDoc.setFontSize(8)
                pdfDoc.text(footer, pageWidth / 2 - (pdfDoc.getTextWidth(footer) / 2), pageHeight - 15, {baseline: 'bottom'});

            }
        }).then(() => {
            pdfDoc.save(`${driver}.pdf`);
        });
    }

    const onToolbarPreparing = (e) => {

        const {toolbarOptions} = e
        const {items} = toolbarOptions

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                width: 120,
                text: 'Imprimir',
                elementAttr: {id: 'btn-pdf'},
                icon: 'far fa-file-pdf',
                onClick: exportGridPDF
            }
        })
    }

    return (
        <React.Fragment>
            <div className="master-detail-caption">
                <DataGrid
                    dataSource={dataSource}
                    showBorders={true}
                    ref={dataGridRef}
                    onToolbarPreparing={onToolbarPreparing}
                    columnAutoWidth={true}
                >
                    <Column dataField="wayPay" alignment={'center'} caption="Forma de pago"/>
                    <Column dataField="paymentValue" alignment={'center'} caption="Total a pagar"
                            format={{type: 'currency', precision: 2}}/>
                    <Column dataField="valueCollect" alignment={'center'} caption="Valor a cobrar"
                            format={{type: 'currency', precision: 2}}/>
                    <Column dataField="amountPaid" alignment={'center'} caption="Valor a pagar"
                            format={{type: 'currency', precision: 2}}/>
                    <Column dataField="grossValue" alignment={'center'} caption="Valor bruto"
                            format={{type: 'currency', precision: 2}}/>
                    <Column dataField="cardCommission" alignment={'center'} caption="Comision tarjeta"
                            format={{type: 'currency', precision: 2}}/>
                    <Column dataField="netCompany" alignment={'center'} format={{type: 'currency', precision: 2}}
                            caption="Neto empresa" dataType="number"/>

                    <Summary>
                        <TotalItem
                            column="paymentValue"
                            summaryType="sum"
                            displayFormat="Total: {0}"
                            valueFormat={{type: 'currency', precision: 2}}/>
                        <TotalItem
                            column="amountPaid"
                            summaryType="sum"
                            displayFormat="Total: {0}"
                            valueFormat={{type: 'currency', precision: 2}}/>
                        <TotalItem
                            column="cardCommission"
                            summaryType="sum"
                            displayFormat="Total: {0}"
                            valueFormat={{type: 'currency', precision: 2}}/>
                        <TotalItem
                            column="netCompany"
                            summaryType="sum"
                            valueFormat={{type: 'currency', precision: 2}}
                            displayFormat="Total: {0}"
                            showInGroupFooter={true}/>
                    </Summary>
                </DataGrid>

            </div>
        </React.Fragment>
    )
}

export default inject('DataStore')(observer(DetailTemplate));
